import { render, staticRenderFns } from "./SoftwarePage.vue?vue&type=template&id=2aeffe7f"
import script from "./SoftwarePage.vue?vue&type=script&lang=js"
export * from "./SoftwarePage.vue?vue&type=script&lang=js"
import style0 from "./SoftwarePage.vue?vue&type=style&index=0&id=2aeffe7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports